// import React, { Fragment } from 'react'
// import {
//   RoomInfoWrapper,
//   StyleLabel,
//   StyleMatchroomContainer,
//   StyleMatchroomInfo,
//   StyleMatchroomTitle,
//   StyleTextContaienr,
// } from './style'
// import theme from '@utils/theme'

// const MatchroomDetails = ({ item }: any) => {
//   const settings = item?.infos?.gameSettings ?? {}
//   console.log(item?.infos)
//   const game = item?.type ?? 'N/A'
//   const isPubg = game?.toLowerCase() === 'pubg'

//   return (
//     <Fragment>
//       <StyleMatchroomTitle>Match Room Details</StyleMatchroomTitle>
//       <StyleMatchroomContainer>
//         <div style={{ display: 'flex', gap: '18px' }}>
//           <StyleMatchroomInfo>
//             <StyleLabel>Game Mode</StyleLabel>
//             <StyleTextContaienr>{settings.mode || 'N/A'}</StyleTextContaienr>
//           </StyleMatchroomInfo>
//           <StyleMatchroomInfo>
//             <StyleLabel>Team Size</StyleLabel>
//             <StyleTextContaienr>{item?.teamSize || 'N/A'}</StyleTextContaienr>
//           </StyleMatchroomInfo>
//         </div>

//         <StyleMatchroomInfo>
//           <StyleLabel>Game Time</StyleLabel>
//           <StyleTextContaienr>
//             {item?.date || 'N/A'} {item?.slot || 'N/A'}
//           </StyleTextContaienr>
//         </StyleMatchroomInfo>

//         {isPubg && (
//           <StyleMatchroomInfo>
//             <StyleLabel>Preferred Map</StyleLabel>
//             <StyleTextContaienr>{settings?.mapType}</StyleTextContaienr>
//           </StyleMatchroomInfo>
//         )}

//         <div style={{ display: 'flex', gap: '18px' }}>
//           <StyleMatchroomInfo>
//             <StyleLabel>Limited Ammo</StyleLabel>
//             <StyleTextContaienr>
//               {settings.limitedAmmo || 'N/A'}
//             </StyleTextContaienr>
//           </StyleMatchroomInfo>
//           <StyleMatchroomInfo>
//             <StyleLabel>Gun Attribute</StyleLabel>
//             <StyleTextContaienr>
//               {settings.gunAttribute || 'N/A'}
//             </StyleTextContaienr>
//           </StyleMatchroomInfo>
//           <StyleMatchroomInfo>
//             <StyleLabel>Character Skills</StyleLabel>
//             <StyleTextContaienr>
//               {settings.characterSkill || 'N/A'}
//             </StyleTextContaienr>
//           </StyleMatchroomInfo>
//         </div>

//         <div style={{ display: 'flex', gap: '18px' }}>
//           <StyleMatchroomInfo>
//             <StyleLabel>Rounds</StyleLabel>
//             <StyleTextContaienr>{settings.rounds || 'N/A'}</StyleTextContaienr>
//           </StyleMatchroomInfo>
//           <StyleMatchroomInfo>
//             <StyleLabel>Headshot Only</StyleLabel>
//             <StyleTextContaienr>
//               {settings.headshotOnly || 'N/A'}
//             </StyleTextContaienr>
//           </StyleMatchroomInfo>
//           <StyleMatchroomInfo>
//             <StyleLabel>Coins</StyleLabel>
//             <StyleTextContaienr>{settings.coin}</StyleTextContaienr>
//           </StyleMatchroomInfo>
//         </div>

//         {!isPubg && (
//           <>
//             <StyleLabel>Compulsory Weapons</StyleLabel>
//             <div style={{ display: 'flex', gap: '18px' }}>
//               {settings?.weapons?.map((w, i) => (
//                 <StyleTextContaienr key={i}>{w}</StyleTextContaienr>
//               ))}
//             </div>
//             <StyleLabel>Compulsory Armor</StyleLabel>
//             <div style={{ display: 'flex', gap: '18px' }}>
//               {settings?.armors?.map((a, i) => (
//                 <StyleTextContaienr key={i}>{a}</StyleTextContaienr>
//               ))}
//             </div>
//           </>
//         )}

//         <RoomInfoWrapper>
//           <StyleMatchroomInfo>
//             <StyleLabel>Room ID</StyleLabel>
//             <StyleTextContaienr borderColor={theme.colors.text}>
//               {item?.roomId || 'N/A'}
//             </StyleTextContaienr>
//           </StyleMatchroomInfo>
//           <StyleMatchroomInfo>
//             <StyleLabel>Room Password</StyleLabel>
//             <StyleTextContaienr borderColor={theme.colors.text}>
//               {item?.roomPassword || 'N/A'}
//             </StyleTextContaienr>
//           </StyleMatchroomInfo>
//           <StyleMatchroomInfo>
//             <StyleLabel>Entry Fee</StyleLabel>
//             <StyleTextContaienr borderColor={theme.colors.text}>
//               Rs.{item?.entryFee || '0'}
//             </StyleTextContaienr>
//           </StyleMatchroomInfo>
//           <StyleMatchroomInfo>
//             <StyleLabel>Potential Winning</StyleLabel>
//             <StyleTextContaienr borderColor={theme.colors.text}>
//               Rs.{item?.potentialWinning || '0'}
//             </StyleTextContaienr>
//           </StyleMatchroomInfo>
//         </RoomInfoWrapper>
//       </StyleMatchroomContainer>
//     </Fragment>
//   )
// }

// export default MatchroomDetails

import React, { Fragment } from 'react'
import {
  RoomInfoWrapper,
  StyleLabel,
  StyleMatchroomContainer,
  StyleMatchroomInfo,
  StyleMatchroomTitle,
  StyleTextContaienr,
} from './style'
import theme from '@utils/theme'

const MatchroomDetails = ({ item }: any) => {
  const settings = item?.infos?.gameSettings ?? {}
  const game = item?.type ?? 'N/A'
  const isPubg = game?.toLowerCase() === 'pubg'

  // known setting keys already handled separately
  const knownKeys = [
    'mode',
    'limitedAmmo',
    'gunAttribute',
    'characterSkill',
    'rounds',
    'headshotOnly',
    'coin',
    'mapType',
    'weapons',
    'armors',
  ]

  // dynamic (unknown) settings to be rendered automatically
  const dynamicSettings = Object.entries(settings).filter(
    ([key]) => !knownKeys.includes(key),
  )

  // group dynamic settings into chunks of 3 per row
  const chunkedSettings: [string, any][][] = []
  for (let i = 0; i < dynamicSettings.length; i += 3) {
    chunkedSettings.push(dynamicSettings.slice(i, i + 3))
  }

  return (
    <Fragment>
      <StyleMatchroomTitle>Match Room Details</StyleMatchroomTitle>
      <StyleMatchroomContainer>
        {/* Game Mode + Team Size */}
        <div style={{ display: 'flex', gap: '18px' }}>
          <StyleMatchroomInfo>
            <StyleLabel>Game Mode</StyleLabel>
            <StyleTextContaienr>{settings.mode || 'N/A'}</StyleTextContaienr>
          </StyleMatchroomInfo>
          <StyleMatchroomInfo>
            <StyleLabel>Team Size</StyleLabel>
            <StyleTextContaienr>{item?.teamSize || 'N/A'}</StyleTextContaienr>
          </StyleMatchroomInfo>
        </div>

        {/* Game Time */}
        <StyleMatchroomInfo>
          <StyleLabel>Game Time</StyleLabel>
          <StyleTextContaienr>
            {item?.date || 'N/A'} {item?.slot || 'N/A'}
          </StyleTextContaienr>
        </StyleMatchroomInfo>

        {/* PUBG-specific map */}
        {isPubg && (
          <StyleMatchroomInfo>
            <StyleLabel>Preferred Map</StyleLabel>
            <StyleTextContaienr>
              {settings?.mapType || 'N/A'}
            </StyleTextContaienr>
          </StyleMatchroomInfo>
        )}

        {/* Fixed core settings (3-column groups) */}
        <div style={{ display: 'flex', gap: '18px' }}>
          <StyleMatchroomInfo>
            <StyleLabel>Limited Ammo</StyleLabel>
            <StyleTextContaienr>
              {settings.limitedAmmo || 'N/A'}
            </StyleTextContaienr>
          </StyleMatchroomInfo>
          <StyleMatchroomInfo>
            <StyleLabel>Gun Attribute</StyleLabel>
            <StyleTextContaienr>
              {settings.gunAttribute || 'N/A'}
            </StyleTextContaienr>
          </StyleMatchroomInfo>
          <StyleMatchroomInfo>
            <StyleLabel>Character Skills</StyleLabel>
            <StyleTextContaienr>
              {settings.characterSkill || 'N/A'}
            </StyleTextContaienr>
          </StyleMatchroomInfo>
        </div>

        <div style={{ display: 'flex', gap: '18px' }}>
          <StyleMatchroomInfo>
            <StyleLabel>Rounds</StyleLabel>
            <StyleTextContaienr>{settings.rounds || 'N/A'}</StyleTextContaienr>
          </StyleMatchroomInfo>
          <StyleMatchroomInfo>
            <StyleLabel>Headshot Only</StyleLabel>
            <StyleTextContaienr>
              {settings.headshotOnly || 'N/A'}
            </StyleTextContaienr>
          </StyleMatchroomInfo>
          <StyleMatchroomInfo>
            <StyleLabel>Coins</StyleLabel>
            <StyleTextContaienr>{settings.coin || 'N/A'}</StyleTextContaienr>
          </StyleMatchroomInfo>
        </div>

        {/* Non-PUBG compulsory items */}
        {!isPubg && (
          <>
            <StyleLabel>Compulsory Weapons</StyleLabel>
            <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap' }}>
              {settings?.weapons?.length ? (
                settings.weapons.map((w: string, i: number) => (
                  <StyleTextContaienr key={i}>{w}</StyleTextContaienr>
                ))
              ) : (
                <StyleTextContaienr>N/A</StyleTextContaienr>
              )}
            </div>

            <StyleLabel>Compulsory Armor</StyleLabel>
            <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap' }}>
              {settings?.armors?.length ? (
                settings.armors.map((a: string, i: number) => (
                  <StyleTextContaienr key={i}>{a}</StyleTextContaienr>
                ))
              ) : (
                <StyleTextContaienr>N/A</StyleTextContaienr>
              )}
            </div>
          </>
        )}

        {/* Dynamic extra settings (auto-added) */}
        {chunkedSettings.map((group, groupIndex) => (
          <div
            key={groupIndex}
            style={{
              display: 'flex',
              gap: '18px',
              flexWrap: 'wrap',
              marginTop: groupIndex === 0 ? '10px' : '0',
            }}
          >
            {group.map(([key, value], index) => (
              <StyleMatchroomInfo key={index}>
                <StyleLabel>
                  {key
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/^./, (s) => s.toUpperCase())}
                </StyleLabel>
                <StyleTextContaienr>
                  {String(value) || 'N/A'}
                </StyleTextContaienr>
              </StyleMatchroomInfo>
            ))}
          </div>
        ))}

        {/* Room Info */}
        <RoomInfoWrapper>
          <StyleMatchroomInfo>
            <StyleLabel>Room ID</StyleLabel>
            <StyleTextContaienr borderColor={theme.colors.text}>
              {item?.roomId || 'N/A'}
            </StyleTextContaienr>
          </StyleMatchroomInfo>

          <StyleMatchroomInfo>
            <StyleLabel>Room Password</StyleLabel>
            <StyleTextContaienr borderColor={theme.colors.text}>
              {item?.roomPassword || 'N/A'}
            </StyleTextContaienr>
          </StyleMatchroomInfo>

          <StyleMatchroomInfo>
            <StyleLabel>Entry Fee</StyleLabel>
            <StyleTextContaienr borderColor={theme.colors.text}>
              Rs.{item?.entryFee || '0'}
            </StyleTextContaienr>
          </StyleMatchroomInfo>

          <StyleMatchroomInfo>
            <StyleLabel>Potential Winning</StyleLabel>
            <StyleTextContaienr borderColor={theme.colors.text}>
              Rs.{item?.potentialWinning || '0'}
            </StyleTextContaienr>
          </StyleMatchroomInfo>
        </RoomInfoWrapper>
      </StyleMatchroomContainer>
    </Fragment>
  )
}

export default MatchroomDetails
